import React from "react";

export const SLoader = () => {
  return (
    <div className="flex items-center justify-center">
      <div className="relative">
        <div className="h-24 w-24 rounded-full border-t-8 border-b-8 border-gray-200"></div>
        <div className="absolute top-0 left-0 h-24 w-24 rounded-full border-t-8 border-b-8 border-violet-500 animate-spin">
        </div>
        {/* --- Customization Start --- */}
        {/* This div centers the 'S' on top of the spinning circles */}
        <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
            <span className="text-5xl font-bold text-violet-500">
                S
            </span>
        </div>
        {/* --- Customization End --- */}
      </div>
    </div>
  );
};